import * as React from "react";
import { getOnboardData } from "../../libs/onboard";
import produce from "immer";

// set to jason link
const chadLink =
  "https://my.setmore.com/bookingpage/759bdc0d-9566-472d-af1a-7a3e4db5b6b4/resourcebookingpage/rdab01468954997319";
const emaleeLink =
  "https://my.setmore.com/bookingpage/759bdc0d-9566-472d-af1a-7a3e4db5b6b4/resourcebookingpage/r287b1463760265242";

interface IProps extends IOnboardStepProps {}

interface IState {
  infoGrabData?: ICompanyInfoGrab;
  loading: boolean;
  frameLoading: boolean;
}

class StrategySession extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    infoGrabData: undefined,
    loading: true,
    frameLoading: true,
  };

  componentDidMount() {
    this.props.allowNextStep(true);
    this.props.onBeforeNextStep(() => {
      this.props.setStepComplete();
    });

    getOnboardData(this.props.org).then(resp => {
      this.setState(
        produce<IState>(draft => {
          if (resp.data && resp.data.attributes.companyInfoGrab) {
            draft.infoGrabData = resp.data.attributes.companyInfoGrab;
          }
          draft.loading = false;
        })
      );
    });
  }

  onFrameLoad = () => {
    this.setState({ frameLoading: false });
  };

  render() {
    const { infoGrabData, loading, frameLoading } = this.state;

    if (loading) {
      return null;
    }

    let link,
      missingSize = false;
    if (!infoGrabData || !infoGrabData.orgSize) {
      missingSize = true;
    } else if (
      infoGrabData.orgSize === "1-5" ||
      infoGrabData.orgSize === "6-10"
    ) {
      link = chadLink;
    } else {
      link = emaleeLink;
    }

    return (
      <>
        <div className="panel panel-primary">
          <div className="panel-heading">Strategy Session Scheduling</div>
          <div className="panel-body">
            <p>
              You are now ready for your Strategy Session covering Sales,
              Marketing, Operations, and HR. Let’s avoid the email ping pong and
              get your session started as soon as possible. Choose 'Strategy
              Session' in the pane below to get started.
            </p>
            <p>Proceed to the next step after you've scheduled your session.</p>
          </div>
        </div>
        {missingSize ? (
          <div className="alert alert-danger">
            <strong>Oops!</strong>
            It looks like you may have missed something on the last page. Please
            go back and make sure you have set your organization's size.
          </div>
        ) : (
          <>
            {frameLoading && (
              <div className="columns is-centered">
                <div className="column is-narrow">Loading...</div>
              </div>
            )}
            <iframe
              onLoad={this.onFrameLoad}
              src={link}
              width={"100%"}
              height={"600px"}
            />
          </>
        )}
      </>
    );
  }
}

export default StrategySession;



// WEBPACK FOOTER //
// ./app/javascript/components/onboarding/StrategySession.tsx